import React from 'react'
import styled from 'styled-components'
import { SIZES } from '../styles/theme'
import ProgrammeItem from './ProgrammeItem'

const StyledAgenda = styled.div`
  ${(props) => (props.inHall !== true) && `background: #eaeaea; padding: 4px 12px;` }
  
  .session-title {
    margin-bottom: 0px;
  }
  .session-speaker {
    margin-bottom: 12px;
  }
  .session-title, .session-speaker {
    ${(props) => (props.inHall !== true) && `padding-left: 24px;` }
  }
  
  ${SIZES.mobile} {
    .session-title {
      margin-top: 2px;
    }
    .session-title, .session-speaker {
      ${(props) => (props.inHall !== true) && `padding-left: 0px;` }
    }
  }
`

export default function ProgrammeSession({ programme, replayButton, inHall, handlePlayback }) {
  return (
    <StyledAgenda inHall={inHall}>
      {/* <div className="session-title mt-2">
        <small><strong>{programme.title}</strong></small>
      </div>
      <div className="session-speaker">
        <small>{programme.desc}</small>
      </div>  */}
      {
        programme.timeSlots.map(slot=>
          <ProgrammeItem key={slot.id} item={slot} handlePlayback={handlePlayback} replay={replayButton} inHall={inHall} />
        )
      }
    </StyledAgenda>
  )
}
